import BaseCrudService from "./baseCrud.service";

// Performance: cache simples de árvores já carregadas (persistente até reload)
const _treeCache = {};

export default class FaqService extends BaseCrudService {
	constructor() {
		super("Faq");
	}

	// Árvore Categoria -> Subcategoria -> Perguntas (com respostas) já resolvida por campanha.
	// Usada pela modal pública de FAQ. visible=true traz apenas a FAQ pública.
	listTree(callback, { campaignId, campaignSubdomain, visible } = {}) {
		const cacheKey = `tree_${campaignId || campaignSubdomain || "all"}_${visible}`;
		let request;

		if (_treeCache[cacheKey]) {
			request = Promise.resolve(_treeCache[cacheKey]);
		} else {
			request = this.getRequest("Tree", { campaignId, campaignSubdomain, visible }).then(data => {
				_treeCache[cacheKey] = data;
				return data;
			});
		}

		if (callback) request.then(callback);
		return request;
	}

	// Árvore para o admin da campanha (sem cache): KB resolvida pela lei de incentivo da campanha
	// + perguntas específicas, agrupadas por categoria/subcategoria. Sem filtro visible => traz tudo.
	treeForAdmin(campaignId) {
		// includeDisabled=true: traz tambem as perguntas KB desativadas nesta campanha,
		// para o admin poder reativa-las (o consumo doador/IA nao envia essa flag).
		return this.getRequest("Tree", { campaignId, includeDisabled: true });
	}

	// Lista completa de categorias ativas + subcategorias aninhadas — usada no admin para classificar perguntas.
	listAllCategories() {
		return this.getRequest("ListCategories");
	}

	// Índice enxuto (só categorias/subcategorias com perguntas) — usado no drill-down do agente.
	listCategories(params = {}) {
		return this.getRequest("Categories", params);
	}

	// Perguntas de uma subcategoria específica.
	listQuestions(params = {}) {
		return this.getRequest("Questions", params);
	}

	// ---- CRUD admin de categorias / subcategorias ----
	// silent=true: sem loader global e sem mensagem (usado no reorder otimista).
	saveCategory(category, silent = false) {
		return this.postRequest("SaveCategory", category, !silent, !silent);
	}

	deleteCategory(id) {
		return this.deleteRequest("DeleteCategory", { id });
	}

	// silent=true: sem loader global e sem mensagem (usado no reorder otimista).
	saveSubcategory(subcategory, silent = false) {
		return this.postRequest("SaveSubcategory", subcategory, !silent, !silent);
	}

	deleteSubcategory(id) {
		return this.deleteRequest("DeleteSubcategory", { id });
	}
}
